module.exports = __webpack_public_path__ + "img/RW.d1d49630.png";